import { makeStyles, TextField } from '@material-ui/core';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => {
  const colors = theme.palette;

  return {
    root: {
      width: '100%'
    },
    input: {
      '&:before': {
        display: 'none'
      },
      '&:after': {
        display: 'none'
      }
    },
    field: {
      border: '2px solid',
      borderRadius: '4px',
      paddingLeft: '.65rem',
      paddingRight: '.65rem'
    },
    noError: {
      color: colors.grey.dark,
      borderColor: colors.grey.medium,
      '&:hover': {
        borderColor: colors.accent.main,
        color: colors.accent.main
      },
      '&:focus': {
        borderColor: colors.primary.main,
        color: colors.primary.main,
        backgroundColor: colors.primary.light
      },
      '&:disabled': {
        pointerEvents: 'none',
        backgroundColor: colors.grey.light
      }
    },
    error: {
      ...theme.errorStyles
    }
  };
});

const TextInput = ({ value, onChange, error, disabled }) => {
  const classes = useStyles();

  const onValueChange = e => {
    onChange(e.target.value);
  };

  return (
    <TextField
      value={value}
      onChange={onValueChange}
      className={classes.root}
      error={error}
      disabled={disabled}
      InputProps={{
        classes: {
          root: classes.input,
          input: `${classes.field} ${error ? classes.error : classes.noError}`
        }
      }}
    />
  );
};

TextInput.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.bool,
  disabled: PropTypes.bool
};

TextInput.defaultProps = {
  error: false,
  disabled: false
};

export default TextInput;
